import('./standaloneApp');
